<section class="topNavbar px-3 sticky-top" id="editNavbar">
    <div class="d-flex justify-content-between p-2" style="height: 60px;">
        <div style="min-width: 40px;">
            <div *ngIf="showBack">
                <button mat-icon-button (click)="navBack()">
                    <mat-icon>keyboard_backspace</mat-icon>
                </button>
            </div>
        </div>
        <div style="align-self: center;">
            <div *ngIf="title$ | async as title">{{title}}</div>
        </div>
        <div style="min-width: 40px;">
            <div *ngIf="showAdd">
                <button mat-icon-button (click)="addSettingItem()" [disabled]="createRight">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>

</section>

<div class="settings-locked-hint m-3 px-3" *ngIf="isSubContext">
    <mat-icon>lock</mat-icon>
    <span>{{ 'COCKPIT.SETTINGS.only_central_mandate' | translate }}</span>
</div>

<section class="m-3 px-3 " [class.settings-locked]="isSubContext">
<ng-template injectComp></ng-template>
</section>